module.exports = __webpack_public_path__ + "img/icon-apple.1e3aefcc.svg";